import { z } from "zod";
import { nullableDateField, latLonSchema } from "./_shared.js";

// ---------------------------------------------------------------------------
// Inlined from trusstor_dashboard/shared/interfaces/ProjectPackageType.enum.ts
// ---------------------------------------------------------------------------

export enum ProjectPackageTypeEnum {
  monitor = "monitor",
  management = "management",
  bundle = "bundle",
}

// ---------------------------------------------------------------------------
// Project  (from trusstor_dashboard/shared/interfaces/IProject.ts)
// ---------------------------------------------------------------------------

export const workDayHoursSchema = z
  .object({
    startDayTime: z.string().nullable().optional(),
    endDayTime: z.string().nullable().optional(),
    dailyWorkerHours: z.number(),
  })
  .passthrough();

export type IWorkDayHours = z.infer<typeof workDayHoursSchema>;

export const responsibleManagerSchema = z
  .object({
    name: z.string(),
    mail: z.string(),
    phone: z.string().optional(),
  })
  .passthrough();

export type IResponsibleManager = z.infer<typeof responsibleManagerSchema>;

export const projectSchema = z.looseObject({
  _id: z.string(),
  name: z.string(),
  organizationId: z.string(),
  city: z.string(),
  countryShortName: z.string().optional(),
  projectId: z.string(),
  isEnabled: z.boolean(),
  language: z.string(),
  workDayHours: z.array(workDayHoursSchema),
  centerLocation: latLonSchema.optional(),
  tz: z.string(),
  startDate: nullableDateField.optional(),
  endDate: nullableDateField.optional(),
  expectedDailyWorkforce: z.number().default(0),
  responsibleManager: responsibleManagerSchema.optional(),
  isExecutiveViewEnabled: z.boolean().optional(),
  isDemo: z.boolean().optional(),
  packageType: z.enum(ProjectPackageTypeEnum),
  orderIndex: z.number().nullable().optional(),
});

export type IProject = z.infer<typeof projectSchema>;
